import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { Flex, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Importer } from '@feathr/blackbox';
import { Icon, Text } from '@feathr/components';
import { getImportFailureMessage } from '@feathr/extender/utils/importFailureMessage';
import { cssVar } from '@feathr/hooks';

interface IFailureReasonLineProps {
  importer: Importer;
}

/**
 * A warning icon and the API's sentence for why a failed import failed, or the generic sentence
 * when it stored none. Nothing for any other state.
 */
function FailureReasonLine({ importer }: Readonly<IFailureReasonLineProps>): JSX.Element | null {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  if (importer.get('state') !== 'failed') {
    return null;
  }

  const sentence = getImportFailureMessage(importer.get('failure_message'), t);

  return (
    <Flex align={'center'} gap={theme.spacing['1']}>
      <Icon color={cssVar('--color-warning')} icon={faExclamationTriangle} />
      <Text.DefaultRegular>{sentence}</Text.DefaultRegular>
    </Flex>
  );
}

export default observer(FailureReasonLine);
